<template>
  <div>
    <div class="info-body">
      <div class="left-container">
        <div class="left-top">
          <div class="img-container">
            <img
              :src="
                require(`assets/pics/${
                  isNotebook(this.systemInfo.type) ? 'laptop.png' : 'desktop.png'
                }`)
              "
              alt=""
            />
            <div v-if="isNotebook(this.systemInfo.type)" class="battery-container">
              <div class="battery-title">
                {{ lanpack.btTitle }}
              </div>
              <div class="battery-info">
                <div class="battery-percent"
                  :style="'width:' + (batteryPercent - 3) + '%'">
                  {{ batteryPercent }}%
              </div>
              </div>
              <div class="battery-cap"></div>
              <img
                class="charge-image"
                style="width: 20px; height: 24px"
                :src="require(`assets/pics/${batteryCharge ? 'charge.png' : 'uncharge.png'}`)"
                alt=""
                @dblclick="alertSystemInfo"
              />
            </div>
            <div
              v-if="isNotebook(this.systemInfo.type)"
              class="battery-button"
              @click="showBatteryDialog"
            >
              <i class="el-icon-warning" v-if="batteryHealth < 80"></i> {{ lanpack.btDetail }}
            </div>
          </div>
          <div class="info-container">
            <div class="system-container">
              <div class="system-title">{{ lanpack.system }}:</div>
              <div class="system-detail">{{ systemInfo.os }}</div>
            </div>
            <div class="system-container">
              <div class="system-title">{{ lanpack.cpu }}:</div>
              <div class="system-detail" style="letter-spacing: -0.1em">
                {{ systemInfo.processor }}
              </div>
            </div>
            <div class="system-container">
              <div class="system-title">{{ lanpack.memorySize }}:</div>
              <div class="system-detail">
                {{ systemInfo.memory }} {{ memoryType }} ({{ lanpack.maxSupport }}:
                {{ memoryMax }}GB)
              </div>
            </div>
            <div class="system-container">
              <div class="system-title">{{ lanpack.memoryInfo }}:</div>
              <div class="system-detail">
                {{ lanpack.slotNum }}: {{ memoryInfo.length }}/{{ memoryInfo.length + emptySlot }}
              </div>
              <div class="icon-container">
                <el-tooltip v-for="(item, index) in memoryInfo" :key="index" placement="top">
                  <template #content
                    >{{ lanpack.slot }}: {{ item.slot }}<br />
                    {{ lanpack.capacity }}: {{ item.capacity }}<br />
                    {{ lanpack.type }}: {{ item.type }}<br />
                    {{ lanpack.speed }}: {{ item.speed }}MHz<br />
                  </template>
                  <img src="~assets/pics/ram_on.png" alt="" srcset="" />
                </el-tooltip>
                <el-tooltip
                  v-for="index of emptySlot"
                  :key="index + 1"
                  placement="top"
                  :content="lanpack.emptySlot"
                >
                  {{ index }}
                  <img src="~assets/pics/ram_off.png" alt="" srcset="" />
                </el-tooltip>
              </div>
            </div>
            <div class="system-container">
              <div class="system-title">{{ lanpack.address }}:</div>
              <div class="system-detail">{{ systemInfo.ip }}</div>
            </div>
            <div class="system-container">
              <div class="system-title">{{ lanpack.mac }}:</div>
              <div class="system-detail">{{ systemInfo.mac }}</div>
            </div>
            <div class="system-container">
              <div class="system-title">{{ lanpack.name }}:</div>
              <div class="system-detail">{{ systemInfo.pc }}</div>
            </div>
            <div class="system-container">
              <div class="system-title">{{ lanpack.domain }}:</div>
              <div class="system-detail">{{ systemInfo.domain }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="left-middle">
          <div
            class="can-replace"
            v-bind:class="languages.lan === 'en' ? 'en-replace' : ''"
            v-if="pcGrantDatas.scrapDays <= 0"
          >
            {{ lanpack.replaceable }}
          </div>
          <div v-if="pcGrantDatas.scrapDays > 0">
            <div class="left-middle-top">
              <div class="middle-title">
                {{ lanpack.leftFor }}
              </div>
              <div class="middle-days">{{ needDays + lanpack.day }}</div>
            </div>
            <div class="left-middle-bottom">
              {{ lanpack.withU + ': ' }}
              <span class="middle-used">{{ usedDays + lanpack.day }}</span>
              <span v-if="grantTime">{{ lanpack.grantTime }} {{ ': ' + grantTime }}</span>
              <span v-if="!grantTime">{{ lanpack.biosTime }} {{ ': ' + biosTime }}</span>
            </div>
          </div>
          <div v-else>
            <div class="left-middle-container">
              <div class="left-middle-left">
                <div class="left-middle-top2">
                  <div class="middle-title">
                    {{ lanpack.overWork }}
                  </div>
                  <div class="middle-days">{{ overDays + lanpack.day }}</div>
                </div>

                <div class="left-middle-bottom2">
                  {{ lanpack.withU + ': ' }}
                  <span class="middle-used">{{ usedDays + lanpack.day }}</span>
                </div>
              </div>

              <img
                :src="
                  require(`assets/pics/systeminfo/${linkHover ? 'link_hover_cn' : 'link_cn'}.png`)
                "
                v-if="languages.lan === 'cn'"
                alt=""
                class="middle-img-link"
                @mouseenter="linkHover = true"
                @mouseleave="linkHover = false"
                @click="linkDoc"
              />
              <img
                :src="
                  require(`assets/pics/systeminfo/${linkHover ? 'link_hover_en' : 'link_en'}.png`)
                "
                v-else
                alt=""
                class="middle-img-link"
                @mouseenter="linkHover = true"
                @mouseleave="linkHover = false"
                @click="linkDoc"
              />
            </div>
          </div>
        </div> -->
        <div class="left-bottom">
          <div class="progress-container">
            <el-progress
              type="circle"
              :width="100"
              :height="100"
              :stroke-width="10"
              :color="colors"
              :percentage="performance.cpu"
            ></el-progress>
            <div class="prgress-title">{{ lanpack.cpuUse }}</div>
          </div>
          <div class="progress-container">
            <el-progress
              type="circle"
              :width="100"
              :height="100"
              :stroke-width="10"
              :color="colors"
              :percentage="performance.memory"
            ></el-progress>
            <div class="prgress-title">{{ lanpack.memoUse }}</div>
            <el-tooltip
              v-if="!isCleaning"
              :content="lanpack.clearMemory"
              :visible-arrow="false"
              placement="top"
              popper-class="tooltip-style"
            >
              <img src="~/assets/pics/clear.png" alt="" class="clear-button" @click="memoryClear" />
            </el-tooltip>
            <div v-if="isCleaning" class="clear-button">
              <i class="el-icon-loading"></i>
            </div>
          </div>
          <div class="progress-container">
            <el-progress
              type="circle"
              :width="100"
              :height="100"
              :stroke-width="10"
              :color="colors"
              :percentage="performance.disk"
            ></el-progress>
            <div class="prgress-title">{{ lanpack.diskUse }}</div>
          </div>
        </div>
      </div>
      <div class="right-container">
        <div class="right-top">
          <div class="start-time">{{ lanpack.bootTime }}： {{ bootTime }}</div>
          <div class="start-title">{{ lanpack.runTime }}:</div>
          <div class="time-detail">
            <div :class="getTimeColors(showTime.days)">{{ showTime.days }}</div>
            <div class="time-font">{{ lanpack.day }}</div>
            <div :class="getTimeColors(showTime.days)">{{ showTime.hours }}</div>
            <div class="time-font">{{ lanpack.hour }}</div>
            <div :class="getTimeColors(showTime.days)">{{ showTime.minutes }}</div>
            <div class="time-font">{{ lanpack.min }}</div>
            <div :class="getTimeColors(showTime.days)">{{ showTime.seconds }}</div>
            <div class="time-font">{{ lanpack.sec }}</div>
          </div>
          <div class="time-tip">
            {{ parseInt(showTime.days) >= 15 ? lanpack.timeWarn : lanpack.timeTips }}
          </div>
        </div>
        <div class="right-bottom">
          <div class="disk-container">
            <el-tooltip v-for="(item, index) in diskInfo" :key="index" placement="top">
              <template #content
                >{{ lanpack.model }}: {{ item.name }}<br />
                {{ lanpack.type }}: {{ item.type === 'SSD' ? lanpack.SSD : lanpack.HDD }}<br />
                {{ lanpack.capacity }}: {{ item.size }}<br />
              </template>
              <img
                :src="require(`assets/pics/${item.type === 'SSD' ? 'ssd.png' : 'hdd.png'}`)"
                alt=""
                srcset=""
              />
            </el-tooltip>
            <div class="disk-total">{{ lanpack.diskTotal }}: {{ diskTotal }}GB</div>
          </div>
          <div class="part-container">
            <div class="part-item" v-for="drive in driveInfo" :key="drive.name">
              <div class="part-size">
                {{ drive.label === '' ? lanpack.disk : drive.label }}
                ({{ drive.name }})
              </div>
              <el-progress
                :text-inside="true"
                :stroke-width="22"
                :color="customColors(parseInt(drive.percent))"
                :percentage="parseInt(drive.percent)"
                status="exception"
              ></el-progress>
              <div class="part-avail">
                {{ lanpack.avail }}: {{ drive.avail }}, {{ lanpack.total }}: {{ drive.total }}
              </div>
              <div class="disk-tips" v-if="parseInt(drive.percent) >= 90">
                {{ lanpack.diskTips }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <battery-dialog
      :lan="languages.lan"
      :languages="lanpack"
      :reserveStatus="batteryStatus"
      :health="String(batteryHealth)"
      :details="systemInfo.battery"
      :show="dialogBatteryVisible"
    ></battery-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      custom-class="dialog-container"
      width="744px"
    >
      <div class="doc-container">
        <img
          :src="require(`assets/pics/systeminfo/intro_${languages.lan === 'cn' ? 'cn' : 'en'}.png`)"
          alt=""
        />
        <div type="primary" class="doc-button" @click="linkScript">{{ lanpack.goSelect }}</div>
      </div>
      <div class="doc-close" @click="dialogVisible = false">x</div>
    </el-dialog>
  </div>
</template>

<script>
import BatteryDialog from 'components/dialogs/BatteryDialog.vue';
import { mapMutations, mapActions, mapState } from 'vuex';
import { Loading } from 'element-ui';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  inject: ['homeTemplate'],
  components: {
    BatteryDialog,
  },
  data() {
    return {
      dialogVisible: false,
      linkHover: false,
      docHover: false,
      usedDays: '',
      overDays: '',
      needDays: '',
      isCleaning: false,
      dialogBatteryVisible: false,
      loading: '',
      toolInfo: '',
      bootTime: '',
      showTime: {},
      usedYear: '',
      usedMonth: '',
      pcGrantDatas: '',
      grantTime: '',
      biosTime: '',
      reserveValue: '',
      batteryStatus: '',
      totalSec: 0,
      batteryPercent: '',
      batteryHealth: '',
      batteryCharge: false,
      checkStatus: false,
      timeInterval: '',
      systemCheckInterval: '',
      diskInfo: [],
      memoryInfo: [],
      memorySlot: {},
      diskTotal: 0,
      memoryMax: 0,
      memoryType: '',
      emptySlot: 0,
      systemInfo: {
        os: '',
        processor: '',
        ip: '',
        mac: '',
        pc: '',
        domain: '',
        type: 'Desktop',
        battery: {},
      },
      driveInfo: [],
      performanceInterval: '',
      colors: [
        { color: '#00b86a', percentage: 50 },
        { color: '#ff9500', percentage: 70 },
        { color: '#f5594a', percentage: 90 },
      ],
      performance: { cpu: 0, disk: 0, memory: 0 },
      pvId: '',
    };
  },
  destroyed() {
    this.loading.close();
    clearInterval(this.timeInterval);
  },
  beforeDestroy() {
    clearInterval(this.performanceInterval);
    clearInterval(this.systemCheckInterval);
  },
  methods: {
    ...mapMutations([
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setErrorType',
      'setErrorTips',
      'setPvId',
      'setBatteryRedirectFlag',
    ]),
    ...mapActions(['softwareInstall', 'softApply', 'getPcGrantTime', 'reportError', 'saveLog']),
    linkScript() {
      window.location = this.lanpack.scriptSrc;
      this.saveLog({
        title: 'SystemInfo',
        lan: this.languages.lan,
        target: 'UserOperate',
        description: 'openLittleScript',
      });
      this.dialogVisible = false;
    },
    linkDoc() {
      this.saveLog({
        title: 'SystemInfo',
        lan: this.languages.lan,
        target: 'UserOperate',
        description: 'openDialog',
      });
      this.dialogVisible = true;
    },
    getYearMonth(date) {
      console.log('date', date);
      const startTime = new Date(date);
      const endTime = new Date();
      const startDate =
        startTime.getDate() + startTime.getHours() / 24 + startTime.getMinutes() / 24 / 60;
      const endDate = endTime.getDate() + endTime.getHours() / 24 + endTime.getMinutes() / 24 / 60;
      const date2Mon = endDate >= startDate ? 0 : -1;
      const monthDif =
        (endTime.getYear() - startTime.getYear()) * 12 +
        endTime.getMonth() -
        startTime.getMonth() +
        date2Mon;
      this.usedYear = parseInt(monthDif / 12, 0);
      this.usedMonth = monthDif % 12;
      this.usedDays = tools.getDaySpan(tools.getFormatDay(startTime), tools.getFormatDay(endTime));
      // if (this.usedYear < 5) {
      //   this.needDays = 5 * 365 - this.usedDays;
      // } else {
      //   this.overDays = this.usedDays - 5 * 365;
      // }
      if (this.pcGrantDatas.scrapDays > 0) {
        this.needDays = this.pcGrantDatas.scrapDays;
      } else {
        this.overDays = this.usedDays - this.pcGrantDatas.totalScrapDays;
      }
    },
    checkBattery() {
      navigator.getBattery().then((battery) => {
        this.batteryPercent = battery.level * 100;
        this.batteryCharge = battery.charging;
      });
    },
    isNotebook(type) {
      if (type === 'Notebook' || type === 'Laptop') return true;
      return false;
    },
    async memoryClear() {
      ubtSendTrace(245278, 'pc_status', 'click', 'clear_ram', '', '', this.pvId);
      this.isCleaning = true;
      this.toolInfo = this.toolList.filter((item) => item.name.indexOf('MemoryClear') !== -1);
      if (this.toolInfo.length !== 1) {
        this.setErrorTips('MemoryClear > getToolInfo > No such little tool');
        ubtSendTrace(
          245278,
          'pc_status',
          'error',
          'clear_ram',
          '',
          '',
          this.pvId,
          'No such little tool!',
        );
        this.saveLog({
          title: 'api_error',
          target: 'MemoryClear > getToolInfo',
          description: 'No such little tool!',
        });
        this.isCleaning = false;
        return;
      }
      // local tool check
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.toolInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        ubtSendTrace(245278, 'pc_status', 'error', 'clear_ram', '', '', this.pvId, res.data);
        this.setErrorTips(`MemoryClear > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'MemoryClear > softwareInstall',
          description: res.data,
        });
        this.isCleaning = false;
        return;
      }
      const downType = this.isNewService ? 'silent' : 'littletools';
      const toolData = {
        lan: 'tools',
        type: downType,
        username: this.userInfo.username,
        softid: this.toolInfo[0].id,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(toolData));
      if (this.isNewService) {
        this.homeTemplate.downToolNew('MemoryClear', this.toolInfo[0].id, res, async () => {
          const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
          await socket.sendSocket(2, runCmd, async (rt) => {
            const rst = JSON.parse(rt);
            if (rst.result === 'failed') {
              ubtSendTrace(245278, 'pc_status', 'error', 'clear_ram', '', '', this.pvId, rst.error);
              this.setErrorTips(`MemoryClear > toolrun > ${rt.error_msg}`);
              this.saveLog({
                title: 'command_error',
                target: 'runTool',
                description: rst.error,
                reserve1: 'MemoryClear > toolrun',
              });
              this.isCleaning = false;
              return;
            }
            if (rst.data === 'Tool Exited') {
              this.isCleaning = false;
              ubtSendTrace(245278, 'pc_status', 'clearram_suc', '', '', 'selfhelp', this.pvId);
              this.saveLog({
                title: 'toolrun_success',
                lan: 'tools',
                target: 'MemoryClear',
                description: 'success',
              });
            }
          });
        });
      } else {
        socket.sendSocket(1, `idesk_toolcheck(${socketDatas})`, (rst) => {
          console.log('idesk_toolcheck', rst);
          if (rst.result !== 'match') {
            this.setErrorTips(`MemoryClear > toolCheck > ${rst.error_msg}`);
            this.saveLog({
              title: 'toolcheck_error',
              lan: 'tools',
              target: 'MemoryClear > toolcheck',
              description: rst.error_msg,
            });
            this.isCleaning = false;
            return;
          }
          socket.sendSocket(1, `idesk_toolrun(${socketDatas})`, (rt) => {
            console.log('idesk_toolrun', rt);
            // console.log('socketDatas', socketDatas);
            if (rt.result !== 'toolrun success') {
              this.setErrorTips(`MemoryClear > toolrun > ${rt.error_msg}`);
              this.saveLog({
                title: 'toolrun_error',
                lan: 'tools',
                target: 'MemoryClear',
                description: rt.error_msg,
              });
              this.isCleaning = false;
              return;
            }
            this.isCleaning = false;
            this.saveLog({
              title: 'toolrun_success',
              lan: 'tools',
              target: 'MemoryClear',
              description: 'success',
            });
          });
        });
      }
    },
    getDiskInfo(drive) {
      try {
        const drivers = Object.keys(drive);
        drivers.forEach((item) => {
          const details = drive[item].split('@');
          const name = item;
          const label = details[0];
          const avail = `${Math.round(details[1] / 1024 / 102.4) / 10.0}GB`;
          const total = `${Math.round(details[2] / 1024 / 102.4) / 10.0}GB`;
          const percent = details[3];
          this.driveInfo.push({
            name,
            label,
            avail,
            total,
            percent,
          });
        });
        // console.log('driveInfo', this.driveInfo);
      } catch (error) {
        // console.log('error', error);
      }
    },
    customColors(percentage) {
      if (percentage < 70) {
        return '#00b86a';
      }
      if (percentage < 90) {
        return '#ff9500';
      }
      return '#f5594a';
    },
    getTimeColors(time) {
      if (time < 7) {
        return 'safe-num';
      }
      if (time < 15) {
        return 'warn-num';
      }
      return 'danger-num';
    },
    getTimeCount(sec) {
      let time = {};
      const days = Math.floor(sec / 86400);
      const hours = Math.floor((sec % 86400) / 3600);
      const minutes = Math.floor(((sec % 86400) % 3600) / 60);
      const seconds = Math.floor(((sec % 86400) % 3600) % 60);
      time = {
        days,
        hours,
        minutes,
        seconds,
      };
      return time;
    },
    getBatteryPercent(details) {
      try {
        let percent = (details.FullChargeCapacity * 100) / details.DesignedCapacity;
        if (percent > 100) percent = 100;
        return Math.round(percent * 10) / 10;
      } catch (error) {
        return 'X';
      }
    },
    async runTool() {
      this.toolInfo = this.toolList.filter((item) => item.name.indexOf('SystemInfo') !== -1);
      // console.log('toolInfo', this.toolInfo, this.toolInfo.length);
      if (this.toolInfo.length !== 1) {
        this.setErrorTips('SystemInfo > getToolInfo > No such little tool');
        this.saveLog({
          title: 'api_error',
          target: 'SystemInfo > getToolInfo',
          description: 'No such little tool!',
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      // local tool check
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.toolInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setErrorTips(`SystemInfo > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'SystemInfo > softwareInstall',
          description: res.data,
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      const downType = this.isNewService ? 'silent' : 'littletools';
      const toolData = {
        lan: 'tools',
        type: downType,
        username: this.userInfo.username,
        softid: this.toolInfo[0].id,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(toolData));
      if (this.isNewService) {
        this.homeTemplate.downToolNew('SystemInfo', this.toolInfo[0].id, res, async () => {
          const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
          await socket.sendSocket(2, runCmd, async (rt) => {
            const rst = JSON.parse(rt);
            if (rst.result === 'failed') {
              this.setErrorTips(`SystemInfo > toolrun > ${rst.error}`);
              this.saveLog({
                title: 'command_error',
                target: 'runTool',
                description: rst.error,
                reserve1: 'SystemInfo > toolrun',
              });
              this.setErrorType('apierror');
              this.$router.push('/error');
              return;
            }
            if (rst.data === 'Tool Exited') {
              const resultDatas = { datas: JSON.parse(rst.info) };
              this.handleResultDatas(resultDatas);
            }
          });
        });
      }

      if (this.isNewService) return;
      socket.sendSocket(0, `idesk_toolcheck(${socketDatas})`, (rst) => {
        console.log('idesk_toolcheck', rst);
        if (rst.result !== 'match') {
          this.setErrorTips(`SystemInfo > toolCheck > ${rst.error_msg}`);
          this.saveLog({
            title: 'toolcheck_error',
            lan: 'tools',
            target: 'SystemInfo > toolcheck',
            description: rst.error_msg,
          });
          this.setErrorType('apierror');
          this.$router.push('/error');
          return;
        }
        socket.sendSocket(0, `idesk_toolrun(${socketDatas})`, (rt) => {
          console.log('idesk_toolrun', rt);
          // console.log('socketDatas', socketDatas);
          if (rt.result !== 'toolrun success') {
            this.setErrorTips(`SystemInfo > toolrun > ${rt.error_msg}`);
            this.saveLog({
              title: 'toolrun_error',
              lan: 'tools',
              target: 'SystemInfo',
              description: rt.error_msg,
            });
            this.setErrorType('apierror');
            this.$router.push('/error');
            return;
          }
          this.saveLog({
            title: 'toolrun_success',
            lan: 'tools',
            target: 'SystemInfo',
            description: 'success',
          });
          this.handleResultDatas(rt);
        });
      });
    },
    handleResultDatas(rt) {
      console.log('system info', rt);
      try {
        const {
          start, bios, diskInfo, memoryInfo, memorySlot,
        } = rt.datas;
        this.diskInfo = diskInfo;
        if (memoryInfo !== undefined) {
          this.memoryInfo = memoryInfo;
          this.memoryType = memoryInfo[0].type;
        }
        this.memorySlot = memorySlot;
        this.memoryMax = memorySlot.MaxCapacity / 1024 / 1024;
        this.emptySlot = memorySlot.MemoryDevices - memoryInfo.length;
        this.totalSec = Number(start);
        let diskTotal = 0;
        diskInfo.forEach((disk) => {
          diskTotal += Number(disk.size.replace('GB', ''));
        });
        this.diskTotal = diskTotal;
        if (this.grantTime) {
          this.getYearMonth(this.grantTime);
        } else {
          this.biosTime = bios;
          this.getYearMonth(bios);
        }
        this.timeInterval = setInterval(() => {
          this.totalSec += 1;
          this.showTime = this.getTimeCount(this.totalSec);
          this.checkBattery();
        }, 1000);
        const date = new Date(Date.now() - start * 1000);
        this.bootTime = tools.getFormatDate(date).replace(/-/g, '/');
        // console.log('date', this.bootTime);
        this.systemInfo = { ...rt.datas };
        console.log(this.systemInfo);
        if (this.isNotebook(this.systemInfo.type)) {
          try {
            this.systemInfo.battery = JSON.parse(rt.datas.battery);
            this.batteryHealth = this.getBatteryPercent(this.systemInfo.battery);
          } catch (error) {
            console.log('get battery details:', error);
            this.systemInfo.battery = {};
          }
        } else {
          this.systemInfo.battery = {};
        }
        this.systemInfo.memory = `${Math.round(rt.datas.memory.total / 1024)} GB`;
        this.getDiskInfo(this.systemInfo.drive);
      } catch (error) {
        this.loading.close();
      }
      this.loading.close();
      this.checkStatus = true;
      // 判断是否需要直接打开电池健康窗口
      if (this.batteryRedirectFlag) {
        this.showBatteryDialog();
        this.setBatteryRedirectFlag(false);
      }
      this.runPerformanceShow(rt.datas.memory.total);
    },
    runPerformanceShow(totalMemory) {
      this.performanceInterval = setInterval(async () => {
        if (this.isNewService) {
          await socket.sendSocket(3, '(performance)', async (rt) => {
            const rst = JSON.parse(rt);
            const pst = JSON.parse(rst.data);
            let { cpu, disk } = pst;
            if (cpu > 100) cpu = 100;
            if (disk > 100) disk = 100;
            let memory = (totalMemory - pst.memo) / totalMemory;
            memory = memory > 1 ? 100 : Math.round(memory * 100);
            this.performance.cpu = cpu;
            this.performance.memory = memory;
            this.performance.disk = disk;
          });
        } else {
          socket.sendSocket(0, 'idesk_performance', (pst) => {
            let { cpu, disk } = pst;
            if (cpu > 100) cpu = 100;
            if (disk > 100) disk = 100;
            let memory = (totalMemory - pst.memo) / totalMemory;
            memory = memory > 1 ? 100 : Math.round(memory * 100);
            this.performance.cpu = cpu;
            this.performance.memory = memory;
            this.performance.disk = disk;
          });
        }
      }, 500);
    },
    showBatteryDialog() {
      this.batteryStatus = this.batteryHealthCheck();
      ubtSendTrace(245278, 'pc_status', 'click', 'battery', '', '', this.pvId);
      this.saveLog({
        title: 'toolrun_success',
        lan: this.languages.lan,
        target: 'UserOperate',
        description: 'ShowBatteryDetails',
        reserve1: this.reserveValue,
        reserve2: this.batteryHealth,
        reserve3: this.batteryStatus,
      });
      this.dialogBatteryVisible = true;
    },
    hideBatteryDialog() {
      this.dialogBatteryVisible = false;
    },
    async submitBatteryReport(desc, callback) {
      const pcName = this.deviceName;
      let phone = '';
      const { empcode, displayName } = this.userInfo;
      const userBaseInfo = await this.softApply({ type: 'baseinfo' });
      if (userBaseInfo.status === 'success') {
        const userInfo = userBaseInfo.data;
        phone = userInfo.phone;
      }
      let description = '';
      description += `\r\n${this.lanpack.pcName}: ${this.pcGrantDatas.assetNo}\n`;
      description += `${this.lanpack.btHealth}: ${this.batteryHealth}%\n`;
      description += `${this.lanpack.pcValue}: ${this.reserveValue}\n`;
      description += `${this.lanpack.pcModel}: ${this.pcGrantDatas.model}\n`;
      description += `${this.lanpack.description}: ${desc}\n\n`;
      switch (this.batteryStatus) {
        case 'Repair':
          description += `${this.lanpack.sgReport}\n`;
          break;
        case 'Change':
          description += `${this.lanpack.sgChange}\n`;
          break;
        default:
          description += `${this.lanpack.sgGood}\n`;
          break;
      }

      const reportResult = await this.reportError({
        lan: this.languages.lan,
        type: 'battery',
        empCode: empcode,
        displayName,
        phone,
        pcName,
        description,
      });

      switch (reportResult) {
        case 'success':
          this.$message.success(this.lanpack.reportSuccess);
          this.dialogBatteryVisible = false;
          ubtSendTrace(245278, 'pc_status', 'help', 'battery', '', 'eventhelp', this.pvId);
          break;
        case 'limit':
          this.$message.warning({ message: this.lanpack.reportLimit, duration: 5000 });
          break;
        default:
          this.$message.warning({ message: this.lanpack.reportFail, duration: 5000 });
          break;
      }
      this.saveLog({
        title: 'SystemInfo',
        target: 'ReportErrors',
        description,
        reserve1: reportResult,
      });
      callback(reportResult);
    },
    batteryHealthCheck() {
      // 调整电池健康检测标准
      if (this.batteryHealth > 60) return 'Good';
      if (this.reserveValue === 0) return 'Change';
      if (!this.reserveValue) return 'Repair';
      return this.reserveValue < 800 ? 'Change' : 'Repair';
    },
    alertSystemInfo() {
      this.$message.warning({ message: this.systemInfo, duration: 5000 });
    },
  },
  computed: {
    ...mapState(['languages', 'toolList', 'userInfo', 'deviceName', 'isNewService', 'batteryRedirectFlag']),
    lanpack() {
      return this.languages.systemInfo;
    },
  },
  async created() {
    this.checkBattery();
    let checkIndex = 0;
    this.systemCheckInterval = setInterval(() => {
      checkIndex += 1;
      if (checkIndex === 20 && !this.checkStatus) {
        clearInterval(this.systemCheckInterval);
        this.loading.close();
        this.setErrorTips('SystemInfo > runTools > check timeout');
        this.saveLog({
          title: 'toolcheck_error',
          lan: 'tools',
          target: 'SystemInfo > toolrun',
          description: 'check timeout',
        });
        this.setErrorType('apierror');
        this.$router.push('/error');
      }
    }, 1000);
    this.setErrorTips('');
    this.loading = Loading.service({
      // fullscreen: false,
      target: '.system-container',
      text: this.languages.homeCheck.checking,
      background: 'rgba(0, 0, 0, 0.7)',
    });
    this.setPageNow('SystemInfo');
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(false);
    this.runTool();
    const pcGrantDatas = await this.getPcGrantTime(this.deviceName);
    console.log('getPcGrantTime', pcGrantDatas);
    this.pcGrantDatas = pcGrantDatas;
    this.grantTime = pcGrantDatas.grantTime;
    this.reserveValue = pcGrantDatas.reserveValue;
    this.pvId = ubtRegister('System Info');
    this.setPvId(this.pvId);
  },
};
</script>

<style lang="scss" scoped>
.doc-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 100%;
  }
  .doc-button {
    margin-top: -60px;
    cursor: pointer;
    border-radius: 14px 14px 14px 14px;
    height: 30px;
    width: 130px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background: linear-gradient(-180deg, rgb(0, 183, 255) 0%, rgb(0, 128, 255) 100%);
  }
}
.doc-close {
  position: absolute;
  right: 30px;
  top: 50px;
  width: 30px;
  height: 30px;
  font-size: 20px;
  cursor: pointer;
  text-align: center;
  color: #fff;
}

.battery-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 100%;
  margin-top: 5px;

    .battery-title {
      margin: 0 4px;
    }

    .battery-info {
      display: flex;
      font-size: 12px;
      width: 50px;
      height: 18px;
      border: 2px solid #999;
      border-radius: 2px;
      line-height: 18px;
      z-index: 1;

      .battery-percent {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 16px;
        border: 1px solid #fff;
        background: #00d09f;
      }
    }

    .battery-cap {
      border-radius: 2px;
      background: #999;
      width: 2px;
      height: 14px;
    }

    .charge-image {
      margin-left: 4px;
  }
}

.battery-check {
  margin: 20px 20px 0 20px;
  width: 100px;
  height: 30px;
}
.battery-button {
  box-shadow: 0 1px 3px #ccc;
  width: 110px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(180deg, #00b7ff, #0080ff);
  cursor: pointer;
  text-align: center;
  margin: 20px 15px 0 15px;
  i {
    animation: fade 1500ms infinite;
  }
  @keyframes fade {
    from {
      opacity: 1;
    }
    10% {
      opacity: 0.1;
    }
    to {
      opacity: 1;
    }
  }
}
.battery-button:hover {
  box-shadow: 0 1px 4px #999;
}
.info-body {
  position: absolute;
  top: 70px;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  display: flex;
}
.left-container {
  width: 65%;
  display: flex;
  margin-right: 20px;
  flex-direction: column;
  .left-top {
    position: relative;
    display: flex;
    height: 100%;
    background-color: #f4f9ff;
    border-radius: 10px;
    text-align: center;
    font-size: 14px;
    // padding: 40px 20px;
    .img-container {
      position: relative;
      margin: auto 10px auto 20px;
      display: flex;
      flex-direction: column;
      img {
        height: 110px;
      }
    }

    .info-container {
      margin: auto;
      width: 100%;
      .system-container {
        height: 24px;
        line-height: 24px;
        position: relative;
        display: flex;
        margin-top: 8px;
        font-size: 14px;
        .system-title {
          width: 23%;
          text-align: right;
        }
        .system-detail {
          margin-left: 10px;
        }
        .icon-container {
          background: #e8f1ff;
          align-items: center;
          margin-left: 10px;
          padding-left: 5px;
          border-radius: 3px;
          img {
            cursor: pointer;
            width: 35px;
            margin-top: 2px;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .left-middle {
    margin-top: 15px;
    background-color: #f4f9ff;
    border-radius: 10px;
    font-size: 14px;
    padding: 15px 10px;
    position: relative;
    .can-replace {
      width: 70px;
      background: #00b87a;
      color: #fff;
      position: absolute;
      padding: 3px;
      top: 0px;
      left: 0px;
      border-radius: 10px 0 10px 0;
      text-align: center;
    }
    .en-replace {
      font-size: 12px;
      width: 75px;
    }

    .left-middle-top,
    .left-middle-top2 {
      position: relative;
      justify-content: center;
      align-items: center;
      display: flex;
      font-size: 20px;
      margin-top: 5px;
      .middle-days {
        margin-left: 5px;
        color: #0080ff;
      }
    }
    .left-middle-bottom,
    .left-middle-bottom2 {
      font-size: 10px;
      color: #999;
      text-align: center;
      margin-bottom: 5px;
      margin-top: 5px;
      .middle-used {
        color: #000;
        font-weight: 700;
        margin-right: 10px;
      }
    }
    .left-middle-container {
      display: flex;
      align-items: center;
      justify-content: center;
      .left-middle-left {
        display: flex;
        flex-direction: column;
      }
      .middle-img-link {
        width: 145px;
        height: 53px;
        margin-left: 40px;
        cursor: pointer;
      }
    }
  }

  .left-bottom {
    position: relative;
    height: 230px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    background-color: #f4f9ff;
    border-radius: 10px;
    font-size: 14px;
    padding: 10px;
    overflow-y: auto;
    .progress-container {
      position: relative;
      text-align: center;
      .el-progress {
        margin: 0 30px;
      }
    }
    .clear-button {
      position: absolute;
      cursor: pointer;
      // text-shadow: 1px 1px 1px #000;
      right: 10px;
      top: 0;
      width: 20px;
      height: 20px;
      i {
        font-size: 22px;
      }
    }
  }
}
.time-detail {
  display: flex;
  justify-content: center;
  .time-num {
    font-size: 30px;
    color: #ff9500;
    margin: 5px;
  }
  .time-font {
    margin-top: 23px;
    font-size: 12px;
  }
  .safe-num,
  .warn-num,
  .danger-num {
    font-size: 30px;
    width: 40px;
    text-align: center;
    margin: 5px;
  }
  .safe-num {
    font-size: 30px;
    color: #00b86a;
  }
  .warn-num {
    color: #ff9500;
  }
  .danger-num {
    color: #f5594a;
  }
}

.right-container {
  width: 35%;
  display: flex;
  flex-direction: column;
  .right-top {
    position: relative;
    // height: 140px;
    background-color: #f4f9ff;
    border-radius: 10px;
    text-align: center;
    font-size: 14px;
    padding: 20px 10px 20px 15px;
    .start-title {
      margin-top: 10px;
    }
    .time-tip {
      color: #1466de;
      // margin-top: 5px;
      font-size: 12px;
    }
  }
  .right-bottom {
    position: relative;
    height: 100%;
    margin-top: 15px;
    background-color: #f4f9ff;
    border-radius: 10px;
    padding: 0px;
    font-size: 14px;
    .disk-container {
      position: relative;
      height: 44px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background: #e0eeff;
      padding-left: 20px;
      img {
        margin-top: 3px;
        margin-right: 10px;
        width: 30px;
        cursor: pointer;
      }
      .disk-total {
        position: absolute;
        right: 20px;
        top: 12px;
        font-size: 16px;
        font-weight: 600;
      }
    }
    .part-container {
      overflow-y: auto;
      position: absolute;
      right: 0;
      left: 0;
      bottom: 20px;
      top: 44px;
      .part-item {
        margin: 20px 20px 10px 20px;
        .part-size,
        .part-avail {
          font-size: 12px;
          margin: 3px;
        }
        .disk-tips {
          font-size: 10px;
          color: #1466de;
        }
      }
    }
  }
  ::-webkit-scrollbar {
    width: 20px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    border: 6px solid rgba(0, 0, 0, 0);
    box-shadow: 8px 0 0 #cccccc inset;
  }

  ::-webkit-scrollbar-thumb:hover {
    box-shadow: 8px 0 0 #a5adb7 inset;
  }
}
</style>
<style>
.dialog-container {
  height: 0;
  top: 5%;
}
</style>
